<section class="my-4 py-4">
  <header>
    <button class="text-left" (click)="toggle()">
      <div class="text-grey text-sm">
        <ng-content select="[subheading]"></ng-content>
      </div>
      <h4 class="h4 text-grey-dark" [class.text-opacity-60]="!open">
        <ng-content select="[heading]"></ng-content>
      </h4>
    </button>
  </header>
  <evsb-smooth-height [trigger]="open" (animationDone)="sendAnimationFinished()">
    <main [class.hidden]="!open">
      <ng-content></ng-content>
    </main>
  </evsb-smooth-height>
</section>
